export default __webpack_public_path__ + "static/media/cloud-based-erp.52b2af95.svg";